"use client";

import { useMemo } from "react";
import ChatBot from "@/components/chat-bot";
import { generateUUID } from "lib/utils";

export default function RootPage() {
    const id = useMemo(() => generateUUID(), []);

    // Show chat interface directly at root without any redirects
    return (
        <ChatBot
            initialMessages={[]}
            threadId={id}
            key={id}
        />
    );
}
